export default "__VITE_ASSET__whGMvFiu__"